import { render, staticRenderFns } from "./Ordersub.vue?vue&type=template&id=03fd7704&scoped=true&"
import script from "./Ordersub.vue?vue&type=script&lang=js&"
export * from "./Ordersub.vue?vue&type=script&lang=js&"
import style0 from "./Ordersub.vue?vue&type=style&index=0&id=03fd7704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fd7704",
  null
  
)

export default component.exports